export default __webpack_public_path__ + "static/media/whatsapp-icon.07efa1ef.svg";